import $ from 'jquery';

const SELECTOR = '.google-translate';

export default class Translate {
  constructor(element) {
    this.google = null;
    this.$element = $(element);
    this.load();
  }

  load() {
    // Load Google Translate framework.
    const script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateInit';
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(script);

    // Add window callback function to signal when the framework is ready.
    window.googleTranslateInit = () => {
      this.google = window.google;
      this.add();
    };
  }

  add() {
    this.$element.find(SELECTOR).append(this.translate);
  }

  get translate() {
    return new this.google.translate.TranslateElement(this.settings, 'google-translate');
  }

  get settings() {
    return {
      pageLanguage: 'en',
      layout: this.google.translate.TranslateElement.FloatPosition.BOTTOM_RIGHT,
    };
  }
}



// WEBPACK FOOTER //
// ./Translate.js